import { setShippingMethods, stopLoading, setCurrentOperation, startLoading, setevaluateOrder,setpdpLinkForOrders, setIsShippingDisc, setDoesCouponThresholdExist, setOngoingAction, setIsShippingCouponFree, setValidatedCoupon } from "./application";
import { CartOperation } from "../enums/cartOperation";
import { ShippingMethodOperations} from "../enums/shippingOperation";
import { CouponState } from "../enums/coupon";

import { setCoupon, logError } from "./application";
import { updateGaCartView, updateProductHistoryOnAddAccessory, updateProductHistoryOnQuantityUpdate, updateProductHistoryOnUpsellUpdate } from "../components/shopping-bag/ga-module";

import { cartApi } from "./cart";
import { getCart, newCartApi } from "./newCart";
import { logSentry } from "../utils/sentry";
import shippingActions from "./shippingActions";
import customerActions from "./customerActions";

import {config} from '../utils/config';
import { Page } from "../enums/page";
import { saveAppliedCouponCodeCookie, delete_cookie, set, getBrandKeywordCampaignParameters, get } from "../utils/cookies";
import { applyPromoEvent, errorTrackingGaEvent } from "../utils/analytics/google";
import i18n from '../utils/translations/i18n';
import { discountApi } from "./discount";
import { redirectToURL } from "../utils/url";
import { ReOrder } from "../enums/reOrder";
import Cart from "../models/cart";
import { generatePdpLinkForLineItem} from "../components/shared/sections/my-account/utils";
import { CouponStatus } from "../enums/couponStatus";
import { calculateThresholdStatus, getThresholdFromValidatedCoupon, hasFullDiscount, isShippingCoupon } from "../utils/cart";

declare const window: any;

export const onErrorHandler = ({operation, err, errMsg, api, mainItemId=null, skipSentryLog = false}) => {
    return async (dispatch, getState) => {
        try{
            dispatch(stopLoading());
            dispatch(logError(true, operation, mainItemId));
            const {applicationState: {currentPage}} = getState();
            if(!skipSentryLog) {
                logSentry({
                    'page': currentPage,   
                    'feature': operation,
                    'operation': operation,
                    'errorType': 'ajaxError',
                    'err': err,
                    'func': operation,
                    'api': api,
                    'errMsg': errMsg
                })
            }
        }
        catch(error){
            console.log(error);
            throw error; //eslint-disable-line
        }
    }
}

export const onSuccessHandler = (operation, obj) => {
    return async (dispatch, getState) => {
        try {

            const {applicationState: {user, currentPage, currentOperation, coupon, clientRefresh, evaluateOrder,pdpLinkForOrders,isShippingDisc}} = getState();
            const cart = JSON.parse(JSON.stringify(getCart(getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data ?? {}));
            cart.currentPage = currentPage;
            let specialOfferCookie = getBrandKeywordCampaignParameters(get('np.brandKeywordCampaign')).couponCode;

            dispatch(logError(false, null, null)); 

            const generatePdpData = (obj: any, args: any) => {
              const pdpData: any = {};
              const linkArray = Object.keys(obj);
              const linkArgsMap = new Map(args.Orders.map((order: any) => [order.id, order.lineItems]));
            
              linkArray.forEach((orderId) => {
                const lineItemIds = Object.keys(obj[orderId]);
                pdpData[orderId] = {};
            
                const lineItems:any = linkArgsMap.get(orderId);
                if (lineItems) {
                  const lineItemMap = new Map(lineItems.map((item: any) => [item.id, item.selectionAttributes]));
                    
                  lineItemIds.forEach((lineItemId) => {
                    const v2SelectionAttributes = lineItemMap.get(lineItemId);
                    pdpData[orderId][lineItemId] = generatePdpLinkForLineItem(
                      obj[orderId][lineItemId], 
                      v2SelectionAttributes || undefined // Ensure we pass undefined if v2SelectionAttributes is falsy
                    );
                  });
                }
              });
            
              return pdpData;
            };
     

            switch (operation) {
                case CartOperation.ADDACCESSORY:
                    if (obj?.accessoryLineItemId) {
                        window.pdi.overridePDI('[Cross-sell]{currPageName}_accesories', -1, obj?.accessoryLineItemId);
                    }
                    if(!specialOfferCookie || !cart?.validDiscountCode){
                      updateProductHistoryOnAddAccessory(cart, obj?.mainItemId, 'accessory', currentPage, obj?.itemId)
                      updateGaCartView(cart,coupon,isShippingDisc);
                      dispatch(stopLoading());
                    } 
                    break;
                case CartOperation.ADDMANUAL:
                  if(!specialOfferCookie || !cart?.validDiscountCode) dispatch(stopLoading());
                    break;
                case CartOperation.SAVECUSTOMFIELD:
                    break;
                case CartOperation.ADDUPSELL:
                    if (!specialOfferCookie || !cart?.validDiscountCode) {
                        updateProductHistoryOnUpsellUpdate(cart, obj?.mainItemId);
                        updateGaCartView(cart,coupon,isShippingDisc);
                        dispatch(stopLoading());
                    }
                    break;
                case CartOperation.REMOVEITEM:
                      if(!specialOfferCookie || !cart?.validDiscountCode) {
                        updateGaCartView(cart,coupon,isShippingDisc);
                        dispatch(stopLoading());
                      }
                    break;
                case CartOperation.REMOVEMANUAL:
                  dispatch(stopLoading());
                    break;
                case CartOperation.REMOVECOUPON:
                  delete_cookie('np.brandKeywordCampaign');
                  dispatch(setCoupon({ state: CouponState.INITIAL, code: '', description: '', error: '', details:'',thresholdValue : null}));
                  dispatch(setValidatedCoupon({ state: CouponState.INITIAL}))
                  break;
                case CartOperation.UPDATEQUANTITY:
                  updateProductHistoryOnQuantityUpdate(cart, obj?.lineItemId, 'mainitem', currentPage);
                  updateGaCartView(cart,coupon,isShippingDisc);
                  if(!specialOfferCookie || !cart?.validDiscountCode) dispatch(stopLoading());
                  break;
                case ReOrder.EVALUATEREORDER:
                  const dataReorder: any = evaluateOrder?.dataReOrder?.length > 0 ? [...obj.dataReOrder, ...evaluateOrder?.dataReOrder] : obj.dataReOrder;
                  dispatch(setevaluateOrder({ dataReOrder: dataReorder }));
                  break;
                  case ReOrder.GENERATEPDPLINK:                  
                    const dataForPdpLinkGeneration = pdpLinkForOrders && Object.keys(pdpLinkForOrders).length > 0
                      ? { ...generatePdpData(obj.resp , obj.args), ...pdpLinkForOrders }
                      : { ...generatePdpData(obj.resp, obj.args) };
                    dispatch(setpdpLinkForOrders({ ...dataForPdpLinkGeneration}));
                  break;  
                case CartOperation.ORDERDETAILS:
                  break;
                case ReOrder.REORDER:
                  const { t } = i18n;
                  const { resp, args } = obj;
                  if (resp && resp.data.data && resp.data.data.attributes && resp.data.data.attributes
                    .id && !resp.data.data.error) {
                    set('np.cartId', resp.data.data.attributes.id, 30, "/");
                    // Updating CT Recomendation feedback api
                    const productKey = args.lineItem?.[0]?.productKey || '';
                    const webCode = args.webCode || '';
                    const isHomePageReorder = args.isHomePageReorder || false;
                    if (window.np.CTRecommendations && window.np.CT_UTILS.getRecommendationId && window.np.CT_UTILS.getRecommendationId(productKey)) {
                      window.np.CTRecommendations.updateMetric({
                        recommendationId: window.np.CT_UTILS.getRecommendationId(productKey),
                        action: 'addToCart',
                        item_id: webCode
                      });
                    }
                    let lineItemToAdd = resp?.data?.data?.attributes?.newAddedLineItems?.[0]?resp?.data?.data?.attributes?.newAddedLineItems?.[0]?.id: resp?.data?.data?.attributes?.lineItems?.[0]?.id;
                    if (!isHomePageReorder) {
                      window.pdi.overridePDI('[CAM]{currPageName}_Reorder', -1, lineItemToAdd);
                    } else {
                      window.pdi.savePDIForLineItem(lineItemToAdd);
                    }           
                    currentPage !== Page.SHOPPINGBAG && redirectToURL(`/${config('locale_details').current_sitename}/${t('shopping_cart_details.shoppingPageUrl')}`);
                  }
                  break;
                case CartOperation.VALIDATECOUPON:
                    const {data, couponCode, locale, callApplyCoupon, isAutoApplyCall, isCouponManuallyApplied} = obj;
                    if(data.active){
                          const isProductDiscount: boolean = data?.discountType?.product ?? false;
                          const isShippingDiscount =  dispatch(isShippingCoupon(data));
                          dispatch(setIsShippingDisc(isShippingDiscount))
                          dispatch(setValidatedCoupon({ state: CouponState.VALID}))
                          if(isShippingDiscount){
                            const isShippingCouponDiscountFree =  dispatch(hasFullDiscount(data));
                            dispatch(setIsShippingCouponFree(isShippingCouponDiscountFree))
                          }else{
                            dispatch(setIsShippingCouponFree(false))
                          }
                          if(callApplyCoupon){
                            const threshold = getThresholdFromValidatedCoupon(data)
                            dispatch(setDoesCouponThresholdExist(!!threshold));
                            if(currentPage === Page.CHECKOUTPAYMENT) dispatch(startLoading())
                            if (data.errorMessage?.cart?.[0] != '' || data.description != '' || data.successMessage?.cart?.[0] != '' || data.successMessage?.product?.[0] != '' || data.bannerMessage?.cart?.[0] != ''){
                              await dispatch(setCoupon({state: CouponState.VALID, code: couponCode, description: data.description || data.successMessage?.cart?.[0] || data.successMessage?.product?.[0] || '', error: data.errorMessage?.cart?.[0] || '', details: data.bannerMessage?.cart?.[0] || '', thresholdValue: threshold}));
                            }
                            const payload = {
                              cartId: user?.cartId,
                              isAutoApplyCall: isAutoApplyCall,
                              discountCode:couponCode,
                              isCouponManuallyApplied:isCouponManuallyApplied,
                          };
                          const cart = await getCart(getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data ?? {};
                          if(cart?.id && cart?.mainItemCount > 0) saveAppliedCouponCodeCookie(couponCode);
                          const { isThresholdMet : isCouponThresholdMet } = calculateThresholdStatus(cart, threshold);
                          const skipApplyCoupon = !cart?.discountExists && threshold && !isCouponThresholdMet && !isProductDiscount;
                          if(skipApplyCoupon){
                            dispatch(setValidatedCoupon({ state: CouponState.VALID}))
                            if (data.errorMessage?.cart?.[0] != '' || data.description != '' || data.successMessage?.cart?.[0] != '' || data.successMessage?.product?.[0] != '' || data.bannerMessage?.cart?.[0] != ''){
                              await dispatch(setCoupon({state: CouponState.THRESHOLD_NOT_MET, code: couponCode, description: data.description || data.successMessage?.cart?.[0] || data.successMessage?.product?.[0] || '', error: data.errorMessage?.cart?.[0] || '', details: data.bannerMessage?.cart?.[0] || '', thresholdValue: threshold}));
                            }
                            dispatch(setOngoingAction({name : CartOperation.SKIPAPPLYCOUPON, isAutoApplyCall : isAutoApplyCall,isCouponManuallyApplied:isCouponManuallyApplied }))
                            const { data: newCart } = await dispatch(newCartApi.endpoints.getCartByCartId.initiate({cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn, priceFlag : false , productFlag : false , discountFlag : true , taxFlag : false , shippingFlag : false},{ forceRefetch: true }));
                            await dispatch(newCartApi.util.updateQueryData('getCartByCartId', {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn, priceFlag : false , productFlag : false , discountFlag : true , taxFlag : false , shippingFlag : false}, (draft) => Object.assign({}, newCart)));
                          }
                          !skipApplyCoupon && dispatch(newCartApi.endpoints.addCoupon.initiate(payload));
                        }else{
                          dispatch(setValidatedCoupon({ state: CouponState.VALID}))
                        }
                    }
                    else {
                      let failValue = isCouponManuallyApplied ? 'fail_manual' : 'fail_direct';
                       if(data?.errorCode === CouponStatus.EXPIRED){
                        failValue += '_expired_coupon';
                        dispatch(setValidatedCoupon({ state: CouponState.EXPIRED}))
                       }else{
                        failValue += '_invalid_coupon';
                        dispatch(setValidatedCoupon({ state: CouponState.INVALID}))
                        }
                        dispatch(stopLoading());
                        !isAutoApplyCall && currentPage === Page.SHOPPINGBAG && applyPromoEvent({coupon: couponCode, event_value: failValue})
                        errorTrackingGaEvent('cart',i18n.t('shopping_bag.invalid_discount_counpon_GA'));
                        if(currentPage === Page.CHECKOUTPAYMENT){
                          dispatch(startLoading());
                          await dispatch(newCartApi.endpoints.removeCoupon.initiate({cartId: user.cartId , discountCode:couponCode }));
                        }
                        if(isAutoApplyCall && currentPage !== Page.CHECKOUTPAYMENT){
                          if(cart?.validDiscountCode && cart?.validDiscountCode === couponCode){
                            dispatch(startLoading());
                            await dispatch(newCartApi.endpoints.removeCoupon.initiate({cartId: user.cartId , discountCode:couponCode }));
                          }

                          if(cart?.validDiscountCode && cart?.validDiscountCode !== couponCode){
                            dispatch(setCoupon({ state: CouponState.INITIAL, code: '', description: '', error: '', details: '',thresholdValue : null}));
                            delete_cookie('np.brandKeywordCampaign');
                            await dispatch(discountApi.endpoints.validateCoupon.initiate({ couponCode: cart?.validDiscountCode , 'locale': config('locale'), callApplyCoupon: true, isAutoApplyCall: true}));
                          }

                          if(cart?.validDiscountCode === ''){
                            dispatch(setCoupon({ state: CouponState.INITIAL, code: '', description: '', error: '', details:'',thresholdValue : null}));
                            delete_cookie('np.brandKeywordCampaign');
                          }
                        }
                    }
                    break;
                case CartOperation.GETCART:
                    if (
                      (currentPage === Page.SHOPPINGBAG || currentPage === Page.CHECKOUTSHIPPING) || (currentPage === Page.CHECKOUTPAYMENT && cart?.validDiscountCode === '')
                    ) {
                      dispatch(stopLoading());
                    }
                    if(currentPage === Page.SHOPPINGBAG){
                      if(currentOperation?.name === CartOperation.ADDUPSELL) {
                          updateProductHistoryOnUpsellUpdate(cart, currentOperation?.mainItemId);
                      }
  
                      if(currentOperation?.name === CartOperation.ADDACCESSORY) {
                          updateProductHistoryOnAddAccessory(cart, currentOperation?.mainItemId, 'accessory', currentPage, currentOperation?.itemId)
                      }
  
                      if(currentOperation?.name === CartOperation.UPDATEQUANTITY){
                        updateProductHistoryOnQuantityUpdate(cart, currentOperation?.lineItemId, 'mainitem', currentPage);
                      }
                    }                   

                    currentPage === Page.SHOPPINGBAG && currentOperation?.name && currentOperation?.name !== CartOperation.SAVECUSTOMFIELD && currentOperation?.name !== CartOperation.REMOVEMANUAL && currentOperation.name !== CartOperation.REORDER && currentOperation?.name !== CartOperation.ADDMANUAL && clientRefresh === false && updateGaCartView(cart,coupon,isShippingDisc);
                    break;
                case ShippingMethodOperations.GET_NA_SHIPPING_PRICES:
                    const {shippingMethods} = obj
                    dispatch(setShippingMethods(shippingMethods))
                    if(!cart?.validDiscountCode) dispatch(stopLoading())
            }
            if(operation === CartOperation.ADDUPSELL || operation === CartOperation.ADDACCESSORY || operation === CartOperation.UPDATEQUANTITY) {
              dispatch(setCurrentOperation({ name : operation === CartOperation.ADDUPSELL ? CartOperation.ADDUPSELL : (operation === CartOperation.ADDACCESSORY ? CartOperation.ADDACCESSORY : CartOperation.UPDATEQUANTITY) , mainItemId : obj?.mainItemId, itemId : obj?.itemId , lineItemId: obj?.lineItemId}));
            } else {
                dispatch(setCurrentOperation({name : operation}))
            }
        }
        catch (error) {
            console.log(error);
        }
    }
}

export const addCouponSuccessHandler = (data, isAutoApplyCall,isCouponManuallyApplied) => {
  return async (dispatch, getState) => {
      try {
        const {applicationState: {user, currentPage, coupon,sentryTransactionState,currentOperation,isShippingDisc}} = getState();
        dispatch(logError(false, null, null)); 
        const cart = await getCart(getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data ?? {};
        if(data?.data?.attributes){
          dispatch(setCoupon({state: CouponState.ELIGIBLE, code: coupon.code, description: coupon.description, error: coupon.error, details:coupon?.details || '',thresholdValue : coupon?.thresholdValue || null}));
          const applyCouponCart: any = new Cart(data?.data?.attributes);
          let newCart: any = JSON.parse(JSON.stringify(applyCouponCart));
          await dispatch(newCartApi.util.updateQueryData('getCartByCartId', {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn}, (draft) => Object.assign({}, newCart)));
          const applyCouponEventValue = isCouponManuallyApplied ? CouponStatus.SUCCESS_MANUAL : CouponStatus.SUCCESS_DIRECT;
          !isAutoApplyCall && currentPage === Page.SHOPPINGBAG && applyPromoEvent({coupon: coupon.code, event_value: applyCouponEventValue})
          currentPage === Page.SHOPPINGBAG && updateGaCartView(newCart,coupon,isShippingDisc);
          if(currentPage === Page.SHOPPINGBAG){
            if(currentOperation?.name === CartOperation.ADDUPSELL){
              updateProductHistoryOnUpsellUpdate(newCart, currentOperation?.mainItemId);
            }
            if(currentOperation?.name === CartOperation.ADDACCESSORY){
              updateProductHistoryOnAddAccessory(cart, currentOperation?.mainItemId, 'accessory', currentPage, currentOperation?.itemId)
            }
            if(currentOperation?.name === CartOperation.ADDUPSELL || currentOperation?.name === CartOperation.REMOVEITEM || currentOperation?.name === CartOperation.ADDACCESSORY){
              updateGaCartView(newCart,coupon,isShippingDisc);
            }
        }
          dispatch(stopLoading());          
        }else{
            dispatch(setOngoingAction({name : CartOperation.APPLYCOUPON, isAutoApplyCall : isAutoApplyCall, isCouponManuallyApplied : isCouponManuallyApplied }))
            const { data: cart } = await dispatch(newCartApi.endpoints.getCartByCartId.initiate({cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn, priceFlag : false , productFlag : false , discountFlag : true , taxFlag : false , shippingFlag : false},{ forceRefetch: true }));
            await dispatch(newCartApi.util.updateQueryData('getCartByCartId', {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn}, (draft) => Object.assign({}, cart)));
        }
        if(sentryTransactionState.applyCoupon != null){
          sentryTransactionState.applyCoupon.finish();
        }
      }
      catch (error) {
          console.log(error);
      }
  }
}


export const vatExemptionSuccessHandler = ({cart}) => {
    return async (dispatch, getState) => {
        try {
            const {applicationState: { user }, shippingState : { address : { oldUsbVat, oldVat}}} = getState();
            
            /* updating cart object */
            const cartObj = JSON.parse(JSON.stringify(getCart(getState(), {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn})?.data ?? {}));
            cartObj.USBTax = cart.USBTax;
            cartObj.VAT = cart.VAT;
            cartObj.cartTotal = cart.cartTotal;
            cartObj.VATWithoutShipping = cart.VATWithoutShipping;
            dispatch(newCartApi.util.updateQueryData('getCartByCartId', {cartId: user.cartId, userId: user.userId, isLoggedIn: user.isLoggedIn}, (draft) => Object.assign({}, cartObj)));
            /* updating cart object */

            if(oldVat !== null || oldUsbVat !== null) {
                const newUsbVat = cart.USBTax;
                const newVat = cart.VAT;
            
                let displayMsg = '';
                let defaultMsg = i18n.t('checkout_shipping.price_update_message');
            
                if (newVat !== oldVat) {
                    displayMsg += i18n.t('vat');
                }
                if (newUsbVat !== oldUsbVat && newUsbVat !== 0) {
                    displayMsg += ('/' + i18n.t('shopping_cart_details.usbTax'));
                }
                if (newVat !== oldVat && (oldUsbVat === newUsbVat || newUsbVat === 0)) {
                    displayMsg = i18n.t('checkout_shipping.price_update_message_VAT');
                } else if((newVat !== oldVat || oldUsbVat !== newUsbVat) && newVat !== 0) {
                    displayMsg += (' ' + defaultMsg);
                }
                dispatch(shippingActions.setUpdateVatMsg(displayMsg));
            }
            dispatch(shippingActions.setOldVat(cart?.VAT));
            dispatch(shippingActions.setOldUsbVat(cart?.USBTax));
        }
        catch (error) {
            console.log(error);
        }
    }
}

export const onGetCustomerSuccessHandler = (response) => {
    return async (dispatch, getState) => {
       const {applicationState: {user: { email, isLoggedIn }, currentPage}} = getState();
       dispatch(customerActions.setCustomer(response));
       dispatch(shippingActions.setCustomerVersion(response?.version));
       if(isLoggedIn === 'true'){
            currentPage !== Page.MYACCOUNT && currentPage !== Page.ORDERDETAILS && currentPage !== Page.MYORDERS && dispatch(shippingActions.getPreference(email));
       }
    }
}